import {LitElement, html} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement('zubie-spinner-rings')
export class ZubieSpinnerRings extends LitElement {
  @property({type: String, attribute: 'grow-duration'})
  growDuration?: string = '1.8s';

  @property({type: String})
  height?: string;

  @property({type: String, attribute: 'stroke-width'})
  strokeWidth?: string = '2';

  @property({type: String})
  width?: string;

  override render() {
    return html`
      <svg
        stroke="currentColor"
        width="${this.width}"
        height="${this.height}"
        viewBox="0 0 44 44"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="none" fill-rule="evenodd" stroke-width="${this.strokeWidth}">
          <circle cx="22" cy="22" r="1">
            <animate
              attributeName="r"
              begin="0s"
              dur="${this.growDuration}"
              values="1; 20"
              calcMode="spline"
              keyTimes="0; 1"
              keySplines="0.165, 0.84, 0.44, 1"
              repeatCount="indefinite"
            ></animate>
            <animate
              attributeName="stroke-opacity"
              begin="0s"
              dur="${this.growDuration}"
              values="1; 0"
              calcMode="spline"
              keyTimes="0; 1"
              keySplines="0.3, 0.61, 0.355, 1"
              repeatCount="indefinite"
            ></animate>
          </circle>
          <circle cx="22" cy="22" r="1">
            <animate
              attributeName="r"
              begin="-0.9s"
              dur="${this.growDuration}"
              values="1; 20"
              calcMode="spline"
              keyTimes="0; 1"
              keySplines="0.165, 0.84, 0.44, 1"
              repeatCount="indefinite"
            ></animate>
            <animate
              attributeName="stroke-opacity"
              begin="-0.9s"
              dur="${this.growDuration}"
              values="1; 0"
              calcMode="spline"
              keyTimes="0; 1"
              keySplines="0.3, 0.61, 0.355, 1"
              repeatCount="indefinite"
            ></animate>
          </circle>
        </g>
      </svg>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'zubie-spinner-rings': ZubieSpinnerRings;
  }
}
